export default __webpack_public_path__ + "static/media/g2.3a5d73e7.PNG";